import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Company } from '../../../models/company';
import { SharedDataService } from '../../../services/shared-data.service';
import { UserService } from '../../../services/user.service';
import { AutoUnsubscribe } from '../../../decorators/auto-unsubscribe';
import { DocumentFile } from '../../../models/document-file';
import { ReviewQueueService } from '../../../services/review-queue.service';
import { ReviewQueueItem, DocumentParsingStep } from '../../../models/review-queue-item';

@Component({
    selector: 'app-processing-list',
    templateUrl: './processing-list.component.html',
    styleUrls: ['./processing-list.component.scss'],
    standalone: false
})
@AutoUnsubscribe('subsArr$')
export class ProcessingListComponent implements OnInit {
  subsArr$: Subscription[] = [];
  company: Company;
  bankId:  string;
  isError: Boolean = false;
  documentQueueItems: Array<ReviewQueueItem> = [];
  documentFiles: Array<DocumentFile> = [];

  constructor(private sharedService: SharedDataService,
              private userService: UserService,
              private reviewQueueService: ReviewQueueService,
  ) {
  }

  ngOnInit() {
    this.subsArr$.push(this.sharedService.company$.subscribe((company: Company) => {
      this.company = company;
      if (this.company) {
        this.getQueueItems();
      }
    }));
    this.bankId = this.userService.getBankId();
  }

  getSteps(reviewQueueItem: ReviewQueueItem): Array<DocumentParsingStep> {
    if (reviewQueueItem !== null) {
      return this.reviewQueueService.calculateParsingTrackerSteps(reviewQueueItem);
    }

    return null;
  }

  getQueueItems(): void {
      this.isError = false;
      this.subsArr$.push(
        this.reviewQueueService.queueList(1, 10, true)
          .subscribe(
            data => {
              this.documentQueueItems = (<ReviewQueueItem[]>data.response.objects).
                                        map(item => this.parseItem(item)).
                                        filter(a => a && (a.companyId === this.company.id &&
                                                          a.bankId === this.bankId));
              this.documentFiles = this.documentQueueItems.map(d => d.processingJobPayload.documentFile);
            },
            () => {
              this.isError = true;
            }
          ),
      );
  }

  parseItem(item: ReviewQueueItem): ReviewQueueItem {
    item.fileSuffix = item.fileKey.substr(item.fileKey.lastIndexOf('.') + 1);
    return item;
  }
}
